/**
 * PWA Manager - Smart Install Prompt (Issue #209)
 *
 * Re-enabled from v1.0 no-op. Shows install prompt after auth
 * using hybrid strategy: up to 3 shows OR until explicit dismiss.
 *
 * Renders platform-appropriate install UI:
 * - Android/Chrome: PWAInstallPrompt (uses beforeinstallprompt)
 * - iOS Safari: IOSAddToHomeScreen (manual instructions)
 */

import { useEffect } from 'react';
import { usePWA } from '../contexts/PWAContext';
import { useAuth } from '../hooks/useAuth';
import { PWAInstallPrompt } from './PWAInstallPrompt';
import { IOSAddToHomeScreen } from './IOSAddToHomeScreen';

export function PWAManager() {
  const { user } = useAuth();
  const { showInstallPrompt } = usePWA();

  // Show prompt after user authenticates (delayed for smoother UX)
  useEffect(() => {
    if (!user) return;

    // Already running as installed PWA — no prompt needed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
      !!(window.navigator as { standalone?: boolean }).standalone;
    if (isStandalone) return;

    const timer = setTimeout(() => {
      showInstallPrompt();
    }, 3000); // 3s delay after auth to avoid overwhelming the user

    return () => clearTimeout(timer);
  }, [user, showInstallPrompt]);

  return (
    <>
      <PWAInstallPrompt />
      <IOSAddToHomeScreen />
    </>
  );
}
